import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import { FeaturedIcon } from '@/components/ui/icon';
import { SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar';

interface AddPageSidebarItemProps {
  icon: IconDefinition;
  label: string;
  description: string;
  isSelected: boolean;
  onClick: () => void;
}

export function AddPageSidebarItem({
  icon,
  label,
  description,
  isSelected,
  onClick,
}: AddPageSidebarItemProps) {
  return (
    <SidebarMenuItem>
      <SidebarMenuButton
        isActive={isSelected}
        onClick={onClick}
        className="px-1 py-1.5 focus-visible:ring-inset"
      >
        <FeaturedIcon icon={icon} variant="outlined" colorScheme="secondary" />
        <div className="flex flex-col gap-0.5 min-w-0 flex-1">
          <span className="font-medium truncate">{label}</span>
          <span className="text-xs text-muted-foreground truncate">{description}</span>
        </div>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
}
